import { render, staticRenderFns } from "./LegacyPasswordReset.vue?vue&type=template&id=854a0224"
import script from "./LegacyPasswordReset.vue?vue&type=script&lang=js"
export * from "./LegacyPasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports